import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal } from '@/types/proposal';

/**
 * The proposal AS THE CUSTOMER SEES IT, for presentation mode.
 *
 * Not `useProposal`: that returns the dashboard row, which has no
 * `signatureRequired`, `company` or `timezone` — the customer-facing fields the
 * public page's content component renders from. Reading the dashboard shape
 * there silently drops the signature gate on a proposal sent for a signature,
 * so the customer can only submit an unsigned acceptance the server then
 * refuses.
 */
export function useProposalPresentation(id: string) {
  return useApiQuery<Proposal>({
    queryKey: opsProposalKeys.presentation(id),
    queryFn: () => apiGet<Proposal>(operationsClient, opsProposalEndpoints.presentation(id)),
    enabled: Boolean(id),
  });
}
